import React, { Component } from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import { IntlActions } from "react-redux-multilingual";
import Pace from "react-pace-progress";
import { ToastContainer } from "react-toastify";
// Import custom components
import store from "../../../store";
import {
  get_for_customer,
  get_for_member,
  get_for_merchant,
  get_for_merchant_and_brand,
} from "../../../utils";
import NavBar from "./common/navbar";
import SideBar from "./common/sidebar";
import CartContainer from "./../../../containers/CartContainer";
import Notify from "./../../../containers/Notify";
import { changeCurrency } from "../../../actions";
import { connect } from "react-redux";
import TopBarDark from "./common/topbar-dark";
import LogoImage from "./common/logo";
import LinearProgress from "@material/react-linear-progress";
import "@material/react-linear-progress/dist/linear-progress.css";

class HeaderFive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  /*=====================
         Pre loader
  ==========================*/
  componentDidMount() {
    setTimeout(function () {
      document.querySelector(".loader-wrapper").style = "display: none";
    }, 2000);
  }

  componentWillMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    let number =
      window.pageXOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (number >= 300) {
      if (window.innerWidth < 576) {
        document.getElementById("sticky").classList.remove("fixed");
      } else document.getElementById("sticky").classList.add("fixed");
    } else {
      document.getElementById("sticky").classList.remove("fixed");
    }
  };

  changeLanguage(lang) {
    store.dispatch(IntlActions.setLocale(lang));
  }

  openNav() {
    var openmyslide = document.getElementById("mySidenav");
    if (openmyslide) {
      openmyslide.classList.add("open-side");
    }
  }

  openSearch() {
    document.getElementById("search-overlay").style.display = "block";
  }

  closeSearch() {
    document.getElementById("search-overlay").style.display = "none";
  }

  load = () => {
    this.setState({ isLoading: true });
    fetch().then(() => {
      // deal with data fetched
      this.setState({ isLoading: false });
    });
  };

  render() {
    const {
      location: { pathname },
      user,
    } = this.props;
    return (
      <div>
        <header id="sticky" className="">
          <div className="mobile-fix-option" />
          {/*Top Header Component*/}
          <TopBarDark />
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="main-menu">
                  <div className="menu-left category-nav-left">
                    {pathname.includes("dashboard") && (
                      <div className="navbar d-md-block d-lg-none">
                        <a href="javascript:void(0)" onClick={this.openNav}>
                          <div className="bar-style">
                            <i
                              className="fa fa-bars sidebar-bar"
                              aria-hidden="true"
                            />
                          </div>
                        </a>
                        <SideBar />
                      </div>
                    )}
                    <div className="brand-logo">
                      <LogoImage logo={this.props.logoName} />
                    </div>
                  </div>
                  <div className="menu-right pull-right">
                    {/*Top Navigation Bar Component*/}
                    <NavBar />
                    {get_for_customer(
											user,
											<div>
												<div className="icon-nav">
													<ul>
														{/*Header Cart Component */}
														<CartContainer />
													</ul>
												</div>
											</div>
										)}
                    {get_for_member(
                      user,
                      <div>
                        <div className="icon-nav">
                          <ul>
                            {/* Notify component for members */}
                            <Notify />
                          </ul>
                        </div>
                      </div>
                    )}
                    {get_for_merchant_and_brand(
                      user,
                      <div>
                        <div className="icon-nav">
                          <ul>
                            {/* Notify component for merchants and brands */}
                            <Notify />
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.props.loading ? (
            <LinearProgress indeterminate />
          ) : (
            <div style={{ height: "4px", opacity: 0 }} />
          )}
        </header>
        <ToastContainer />
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({ loading: state.global.loading, user: state.auth.user }),
    { changeCurrency }
  )(HeaderFive)
);
